import $ from 'jquery';

export function init({ onVendorToggle = () => {}, onOrgToggle = () => {} } = {}) {
  // Organizations toggle
  $(document).on('click', '.organizations-listing .toggler', function (e) {
    e.preventDefault();
    const $parent = $(this).closest('li.item');
    $parent.toggleClass('active');
    if ($(window).width() > 700) {
      window.ILSFA_scrollBody 
        ? window.ILSFA_scrollBody('#organizations')
        : $('html,body').animate({ scrollTop: $('#organizations').offset().top }, 300);
    } else {
      window.ILSFA_scrollBody 
        ? window.ILSFA_scrollBody('#map-sticky-parent')
        : $('html,body').animate({ scrollTop: $('#map-sticky-parent').offset().top }, 300);
    }
    onVendorToggle(); // resize map container
    if ($parent.hasClass('active') && !$parent.hasClass('no-coords')) {
      onOrgToggle([ $parent.attr('data-lng'), $parent.attr('data-lat') ], $parent.attr('data-title'));
    }
    window.Waypoint.refreshAll();
  });

  // Vendors toggle
  $(document).on('click', '.vendors-listing .toggler', function (e) {
    e.preventDefault();
    $(this).closest('li.item').toggleClass('active');
    onVendorToggle();
    window.Waypoint.refreshAll();
  });

  // Load more (unhide all vendor/event posts) – Bandicoot folded in
  $(document).on('click', '.load-more a, .load_more_posts', function (e) {
    e.preventDefault();
    const $loadMore = $(this).closest('.load-more');

    // Vendor grid
    $('.vendor-grid-section .one-third').removeClass('hidden_post');
    // Events list
    $('.bm_events li, .bm_events h3').removeClass('hidden_post');

    // Cards container logic from v11
    $('.cards').each(function () {
      const $cards = $(this);
      if ($cards.find('.item.map-point').length > 10) {
        $cards.find('.item.map-point:gt(9)').removeClass('hidden');
        $cards.find('.item.map-point:gt(9)+h3.event-heading').removeClass('hidden');
        $loadMore.addClass('hidden');
      }
    });

    const $moreContainer = $loadMore.parents('[data-load-more-parent]').find('[data-load-more-container]');
    if ($moreContainer.hasClass('compact-grid')) $moreContainer.masonry();
    if (window.Waypoint) window.Waypoint.refreshAll();

    $(this).hide();
  });

  // Approved Vendor Offers filters – Bandicoot folded in
  $('.vendor_offer_filters input[name="offer_filter"]').on('change', function () {
    const offerId = $(this).data('offer');
    $('#' + offerId).toggle($(this).is(':checked'));
  });

  // Copy link buttons – Bandicoot folded in
  // Replace the old .copy_link handler in lists.js with this:
  $(document).on('click', '.copy_link', async function (e) {
    e.preventDefault();
    const link = $(this).attr('href');

    // Preferred path: async Clipboard API
    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(link);
        alert('Link copied to clipboard: ' + link);
        return;
      } catch (err) {
        // fall through to fallback
      }
    }

    // Fallback: temporary textarea + selection (no execCommand)
    try {
      const $tmp = $('<textarea readonly aria-hidden="true" style="position:fixed; left:-9999px; top:-9999px; opacity:0; pointer-events:none;"></textarea>');
      $('body').append($tmp);
      $tmp.val(link)[0].select();            // expose selection to user
      // Try Clipboard API again with selected text (some browsers relax after selection)
      if (navigator.clipboard && window.isSecureContext) {
        try {
          await navigator.clipboard.writeText(link);
          $tmp.remove();
          alert('Link copied to clipboard: ' + link);
          return;
        } catch (err2) { /* continue */ }
      }
      // Last resort: inform user and leave text selected for manual copy
      alert('Press Ctrl/Cmd+C to copy this link:\n\n' + link);
      // keep the selection so user can copy immediately
      setTimeout(() => { $tmp.remove(); }, 5000);
    } catch (fallbackErr) {
      // Absolute last fallback — just show the link
      prompt('Copy this link:', link);
    }
  });
}
